import React, { useState, Dispatch, SetStateAction, useEffect } from "react"
import "twin.macro"
import { useTranslation } from "next-i18next"
import {
  UserOnGetUserFragmentFragment,
  ProfileOnGetProfileFragment,
  SupportPaymentDetailFragment,
} from "../../graphql/generated/graphql"
import { SupportPayment } from "../askQuestion/supportPayment"
import { ReactComponent as Logo } from "../../assets/icons/bonsai_logo.svg"
import { StripePaymentRequestButtonElement } from "@stripe/stripe-js"

interface PaymentGateProps {
  user: UserOnGetUserFragmentFragment
  artist: ProfileOnGetProfileFragment
  setShowPaymentGate: Dispatch<SetStateAction<boolean>>
  supportPayment: SupportPaymentDetailFragment
}

export const PaymentGateModal = ({ user, artist, setShowPaymentGate, supportPayment }: PaymentGateProps) => {
  const { t } = useTranslation("question")
  const [questionBody, setQuestionBody] = useState<string>("")
  const [errorMessage, setErrorMessage] = useState("")
  const [paymentButton, setPaymentButton] = useState<StripePaymentRequestButtonElement | null>(null)
  const price = supportPayment.price
  useEffect(() => {
    const priceElement = document.getElementById("price") as HTMLSpanElement
    priceElement.innerHTML = `$${price}.00`
  })

  return (
    <div tw="flex flex-col items-center space-y-6">
      <h1 tw="title-4">{t("payment_gate.title")}</h1>
      <Logo />
      <div tw="space-y-2">
        <p tw="font-bold">{t("payment_gate.message", { artist: artist.name })}</p>
        <p tw="text-base-4 text-center">{t("payment_gate.description")}</p>
      </div>
      <SupportPayment
        {...{
          User: user,
          profile: artist,
          questionBody,
          setQuestionBody,
          setShowPaymentGate,
          errorMessage,
          setErrorMessage,
          paymentButton,
          setPaymentButton,
        }}
      />
      <p tw="text-2xs font-bold" dangerouslySetInnerHTML={{ __html: t("payment_gate.contact_us") }} />
    </div>
  )
}
